<template>
    <v-container grid-list-xl fluid>
        <v-layout row wrap>
            <v-flex lg12>
                <v-card>
                    <hpo-filter :headers="headers" :viewName="viewName" v-on:applyFilter="applyFilter" v-on:quickFilter="quickFilter"></hpo-filter>
                    <v-data-table :headers="headers" :items="items" :options.sync="pagination" :server-items-length="total_rows" :footer-props="items_per_page" :must-sort="true" :loading="loading" :mobile-breakpoint="100">
                        <template v-slot:item="{ item }">
                            <tr>
                                <td>{{ item.id }}</td>
                                <td>{{ item.meimei_code }}</td>
                                <td class="text-start" v-bind:style="{'color': display_color(item.status, order_status)}" >{{ item.status | display_value(order_status) }}</td>
                                <td class="text-start">{{ item.shipment_status | display_value(order_shipment_status) }}</td>
                                <td>{{ item.full_name }}</td>
                                <td>{{ item.product_code }}</td>
                                <td>{{ item.name }}</td>
                                <td>{{ item.option_value }}</td>
                                <td class="text-end">{{ item.qty | currency }}</td>
                                <td class="text-end">
                                    <v-edit-dialog :return-value.sync="item.qty_bought" eager lazy @save="updateItem({id: item.order_product_id, qty_bought: item.qty_bought})">
                                        <div>{{ item.qty_bought | currency }}</div>
                                        <template v-slot:input>
                                            <h-currency-input label="SL mua" v-model="item.qty_bought" class="input-group--focused" :decimal="0"></h-currency-input>
                                        </template>
                                    </v-edit-dialog>
                                </td>
                                <td class="text-end">
                                    <v-edit-dialog :return-value.sync="item.qty_instore" eager lazy @save="updateItem({id: item.order_product_id, qty_instore: item.qty_instore})">
                                        <div>{{ item.qty_instore | currency }}</div>
                                        <template v-slot:input>
                                            <h-currency-input label="SL về" v-model="item.qty_instore" class="input-group--focused" :decimal="0"></h-currency-input>
                                        </template>
                                    </v-edit-dialog>
                                </td>
                                <td class="text-end">
                                    <v-edit-dialog :return-value.sync="item.qty_wrong" eager lazy @save="updateItem({id: item.order_product_id, qty_wrong: item.qty_wrong})">
                                        <div>{{ item.qty_wrong | currency }}</div>
                                        <template v-slot:input>
                                            <h-currency-input label="SL sai" v-model="item.qty_wrong" class="input-group--focused" :decimal="0"></h-currency-input>
                                        </template>
                                    </v-edit-dialog>
                                </td>
                                <td>
                                    <v-edit-dialog :return-value.sync="item.admin_note" eager lazy @save="updateOrderItem({id: item.id, admin_note: item.admin_note})">
                                        <div>{{ item.admin_note }}</div>
                                        <template v-slot:input>
                                            <v-text-field label="Ghi chú" v-model="item.admin_note" class="input-group--focused"></v-text-field>
                                        </template>
                                    </v-edit-dialog>
                                </td>
                            </tr>
                        </template>
                        <template v-slot:body.append v-if="summary">
                          <tr class="total-summary-td">
                              <td colspan="8" class="text-end font-weight-bold">Tổng:</td>
                              <td class="text-end font-weight-bold">{{ summary.qty | currency}}</td>
                              <td class="text-end font-weight-bold">{{ summary.qty_bought | currency}}</td>
                              <td class="text-end font-weight-bold">{{ summary.qty_instore | currency}}</td>
                              <td class="text-end font-weight-bold">{{ summary.qty_wrong | currency}}</td>
                              <td class="text-end font-weight-bold"></td>
                          </tr>
                        </template>
                    </v-data-table>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
    </template>
    
    <script>
    import { mapState } from "vuex";
    import configs from "@/configs";
    import { display_color } from "@/commons/formater";
    import Filtering from "@/components/Filtering";
    import _ from "lodash";
    
    export default {
        components: {
            "hpo-filter": Filtering
        },
        data() {
            return {
                viewName: "check_order",
                dialogItem: false,
                display_color: display_color,
                order_status: configs.ORDER_STATUS,
                order_shipment_status: configs.ORDER_SHIPMENT_STATUS,
                pagination: _.cloneDeep(configs.PAGINATION),
                items_per_page: _.cloneDeep(configs.ITEMS_PER_PAGE),
                filterConditions: [],
                quickFilterConditions: [],
                requireRules: [v => !!v || "Trường dữ liệu không được để trống."],
                headers: [
                    {
                        text: "Mã đơn",
                        value: "id",
                        filterable: true,
                        quickSearch: true,
                        width: "100px",
                        dataType: configs.DATA_TYPE["Number"]
                    },
                    {
                        text: "Mã MeiMei",
                        value: "meimei_code",
                        filterable: true,
                        quickSearch: true,
                        width: "140px",
                        dataType: configs.DATA_TYPE["String"]
                    },
                    {
                        text: "Trạng thái",
                        value: "status",
                        filterable: true,
                        width: "140px",
                        values: configs.ORDER_STATUS,
                        dataType: configs.DATA_TYPE["Enum"]
                    },
                    {
                        text: "Tình trạng",
                        value: "shipment_status",
                        filterable: true,
                        width: "140px",
                        values: configs.ORDER_SHIPMENT_STATUS,
                        dataType: configs.DATA_TYPE["Enum"]
                    },
                    {
                        text: "Họ tên",
                        value: "full_name",
                        filterable: true,
                        quickSearch: true,
                        dataType: configs.DATA_TYPE["String"]
                    },
                    {
                        text: "Mã sản phẩm",
                        value: "product_code",
                        filterable: true,
                        quickSearch: true,
                        dataType: configs.DATA_TYPE["String"]
                    },
                    {
                        text: "Tên sản phẩm",
                        value: "name",
                        filterable: true,
                        quickSearch: true,
                        dataType: configs.DATA_TYPE["String"]
                    },
                    {
                        text: "Thuộc tính",
                        value: "option_value",
                        filterable: true,
                        dataType: configs.DATA_TYPE["String"]
                    },
                    {
                        text: "Số lượng đặt",
                        value: "qty",
                        filterable: true,
                        dataType: configs.DATA_TYPE["Number"],
                        align: "right",
                    },
                    {
                        text: "Số lượng mua",
                        value: "qty_bought",
                        filterable: true,
                        dataType: configs.DATA_TYPE["Number"],
                        align: "right",
                    },
                    {
                        text: "Số lượng về",
                        value: "qty_instore",
                        filterable: true,
                        dataType: configs.DATA_TYPE["Number"],
                        align: "right",
                    },
                    {
                        text: "Số lượng sai",
                        value: "qty_wrong",
                        filterable: true,
                        dataType: configs.DATA_TYPE["Number"],
                        align: "right",
                    },
                    {
                        text: "Ghi chú",
                        value: "admin_note",
                        filterable: true,
                        dataType: configs.DATA_TYPE["String"]
                    },
                ]
            };
        },
        watch: {
            pagination: {
                handler: function (val, oldVal) {
                    let filterConditions = this.$store.state.commons.filterConditions;
                    this.filterConditions = !_.isEmpty(filterConditions) ? filterConditions[this.viewName] : []
                    this.filter_data();
                },
                deep: true
            },
        },
        computed: {
            ...mapState({
                items: state => state.order_check.all.data,
                total_rows: state => state.order_check.all.total,
                summary: state => state.order_check.all.summary,
                loading: state => state.order_check.loading,
                currentItem: (state) => state.order_check.selected
            }),
            adminRole() {
                return this.$store.state.authentication.user.role == configs.ROLE_TYPE.Admin;
            },
            staffRole() {
                return this.$store.state.authentication.user.role == configs.ROLE_TYPE.Staff;
            }
        },
        methods: {
            filter_data: function () {
                var param = {
                    pagination: this.pagination,
                    filter: [...this.filterConditions],
                    quickFilter: this.quickFilterConditions
                };
                this.$store.dispatch("order_check/getList", param);
            },
            applyFilter(filterConditions) {
                let sortBy = this.pagination.sortBy
                let sortDesc = this.pagination.sortDesc
                this.pagination = configs.PAGINATION;
                this.pagination.sortBy = sortBy;
                this.pagination.sortDesc = sortDesc;
                this.filterConditions = filterConditions;
                this.filter_data();
            },
            quickFilter(filterConditions) {
                this.quickFilterConditions = filterConditions;
                this.filter_data();
            },
            updateItem(item) {
                this.$store.dispatch("order_products/setDetail", {id: item.id, data: item}); 
            },
            updateOrderItem(item) {
                this.$store.dispatch("orders/setDetail", {id: item.id, data: item}); 
            }
        },
        mounted() {
            this.$root.$emit('REQUEST_ROOT_OPTION', {});
            this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
        },
        beforeDestroy() {
            this.$root.$off("REQUEST_REFRESH_DATA", this.filter_data);
        }
    };
    </script>
    